import React from 'react';

export const collectionContext = React.createContext({ refreshCollection: null });
